import { render, staticRenderFns } from "./bet-zone-bg.vue?vue&type=template&id=d26d00cc&scoped=true"
import script from "./bet-zone-bg.vue?vue&type=script&lang=js"
export * from "./bet-zone-bg.vue?vue&type=script&lang=js"
import style0 from "./bet-zone-bg.vue?vue&type=style&index=0&id=d26d00cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26d00cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d26d00cc')) {
      api.createRecord('d26d00cc', component.options)
    } else {
      api.reload('d26d00cc', component.options)
    }
    module.hot.accept("./bet-zone-bg.vue?vue&type=template&id=d26d00cc&scoped=true", function () {
      api.rerender('d26d00cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/bet-zone/bet-zone-bg.vue"
export default component.exports